// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".link-btn[data-v-7c31b780]{color:#1976d2;font-size:14px;font-weight:500;cursor:pointer}.title-card[data-v-7c31b780]{color:#192b46;font-size:20px;font-weight:700}.subtitle-card[data-v-7c31b780]{color:#192b46}.discount[data-v-7c31b780],.subtitle-card[data-v-7c31b780]{font-size:16px;font-weight:500}.discount[data-v-7c31b780]{color:#00a65a}.footer-card[data-v-7c31b780]{color:#1976d2;font-size:16px;font-weight:500;text-align:center}", ""]);
// Exports
module.exports = exports;
